import {Box, Card, CardMedia} from "@mui/material";

import {makeStyles} from "@mui/styles";
import React from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

const useStyles = makeStyles((theme) => ({
    card: {
        transition: "transform 0.3s, box-shadow 0.3s",
        cursor: "pointer",
        boxShadow: "var(--Hard-X, 2px) var(--Hard-Y, 2px) var(--Hard-Blur, 8px) var(--Spread, 0px) var(--Shadow, rgba(0, 0, 0, 0.10))",
        borderRadius: "var(--Corner-Radius-Radius-Large, 8px)",
        background: "var(--Colors-White, #FEFEFE)",
        "&:hover": {
            transform: "scale(1.1)"
        }
    },
}));


const TenantAppCard = ({p}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleCardClick = () => {
        if (!p.TenantAppMapping.isactive) {
            toast.info("This app isn't included in your organization's subscription. For access or more information, contact info@trexoglobal.com. Thank you.")
        } else if (!p.authorized) {
            toast.info("You don’t have the required permissions for this application. Please contact your Tenant Admin to request access.")
        }
        else {
            navigate(p.app_home_url)
        }

        dispatch ({
            type : "ACTIVE_APP",
            payload: p.app_name
        });

    }

    const classes = useStyles();

    return (
        <Card className={classes.card} sx={{ height: '100%',width: '90%'}} onClick={handleCardClick} >

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <CardMedia
                    component="img"
                    image={p.app_image_url}
                    alt={p.app_name}
                    sx={{
                        width: "70%",
                        aspectRatio: "1/1",
                        objectFit: "contain"
                    }}
                />
            </Box>
        </Card>

    );
};

export default TenantAppCard;